import React, {useRef} from 'react';
import {swrFetcher} from "../../utils/api.ts";
import useSWRInfinite from "swr/infinite";
import Button from "../form/Button.tsx";
import RenderMediaAsset from "../RenderMediaAsset.tsx";
import DropzoneUploader from "../uploader/DropzoneUploader.tsx";
import {FiCheck} from "react-icons/fi";

const PAGE_SIZE = 50;

const keyFunction = (type: string)=>(pageIndex, previousPageData)=> {
    if(previousPageData && !previousPageData.assets.length){
        return null;
    }
    return `/assets?type=${type}&limit=${PAGE_SIZE}&offset=${(pageIndex*PAGE_SIZE)}`;
}
const imageOnly = keyFunction('image');
const both = keyFunction('image,video');
const videoOnly = keyFunction('video');

interface Asset {
    id: string;
    url: string;
    thumbnail: string;
    type: string;
}

const getKeyFnForType = {
    'image,video': both,
    'image': imageOnly,
    'video': videoOnly,
}



function AssetPicker({value, onChange, max, type = 'image,video'}:{
    value?: Asset[],
    max?: number,
    type: 'image' | 'video' | 'image,video',
    onChange?:(val: Asset[])=>void,
}) {
    const {data, mutate, isValidating, isLoading, size, setSize} = useSWRInfinite(getKeyFnForType[type], swrFetcher,{
        // revalidateIfStale:false,
        //revalidateFirstPage:false,
        revalidateOnFocus:false,
        // revalidateOnMount:false,
    });
    const assets = data?.map(({assets})=>assets).flat() || []
    const dimen = useRef(null);
    const isReachingEnd = data && (!data[data.length - 1].assets.length || data[data.length - 1].assets.length < PAGE_SIZE);
    const width = dimen.current ? dimen.current.offsetWidth : 0;
    const onClick = (asset) => (e)=>{
        if(onChange) {
            if (e) {
                e.preventDefault();
            }
            // if (max && (value || []).length >= max) {
            //     return;
            // }
            const val = value || [];
            if (val.find(({id}) => id == asset.id)) {
                onChange(val.filter(({id}) => id != asset.id))
            } else {
                onChange([...val, asset].slice(0, max || 1000))
            }
        }
    }
    return (
        <React.Fragment>
            <DropzoneUploader parent_id={0} onUpload={()=>mutate()} />
            <div className="grid grid-cols-2 gap-1" ref={dimen}>
            {
                assets.map((asset) => {
                    const has = (value || []).find((i)=>i.id == asset.id);

                    return <div
                              style={{cursor:'pointer'}}
                              onClick={onClick(asset)}  key={String(asset.id)} className={width < 500 ? 'pointer-event col-6' : 'pointer-event col-md-4 col-lg-3 col-sm-6 col-6'}>
                        <div className="rounded-lg border border-base-200 overflow-hidden">
                            <RenderMediaAsset
                                isSelected={!!has}
                                item={asset.data}
                                height={160}/>
                        </div>
                    </div>
                })
            }
            </div>
            {
                !isReachingEnd ?
            <div className="text-center mt-2">
                <Button loading={isLoading || isValidating} className={"btn btn-outline-secondary btn-sm"} onClick={()=>setSize(size+1)}>Load more {size}</Button>
            </div> : null
            }
        </React.Fragment>
    );
}



export default AssetPicker;
